import createRoute from '@widesk-ui/tools/createRoute';
import MailModel   from '@models/mail/MailModel';

export default createRoute.splitView('/mails', 'shop', 'MailSplitView', MailModel.localize('plural'));
